<template>
  <div id="plan">
    <b-modal ref="review-modal" size="lg" scrollable centered @ok="$refs['warning-modal'].show()" title="Review your action plan">
      <div v-html="planContent"></div>

      <template #modal-footer="{ ok, cancel }">
        <b-button size="sm" class="cancel-modal-btn" @click="cancel()">
          Return to Edit
        </b-button>
        <b-button size="sm" pill class="submit-modal-btn" @click="ok()">
          Submit Action Plan
        </b-button>
      </template>
    </b-modal>

    <b-modal ref="warning-modal" size="lg" scrollable centered @ok="submitAction">
      <div class="text-center pb-3">
        <font-awesome-icon class="fa-fw fa-10x" :icon="['fas', 'exclamation-triangle']" />
      </div>
      <h4 class="text-center text-uppercase">Warning Proceed With Caution</h4>
      <h6 class="text-center">
        Once you Submit and Save, the Action Plan forms will be included in the Dealer Report.
      </h6>
      <h6 class="text-center">
        Access this session's report in the Report Export & History Section
      </h6>

      <template #modal-footer="{ ok, cancel }">
        <b-button size="sm" class="cancel-modal-btn" @click="cancel()">
          Back
        </b-button>
        <b-button size="sm" pill class="submit-modal-btn" @click="ok()">
          Submit and Save
        </b-button>
      </template>
    </b-modal>

    <h6 class="page-title">Action Plan</h6>
    <div class="retention-guide">
      <p class="mb-5">Document your dealership’s action steps to achieve their selected priority in the text box below.</p>
    </div>
    <div class="action-plan mt-5">
      <div class="row">
        <div class="col-md-12">
          <h6 class="action-plan-header">Enter dealership action plan</h6>
          <!--                    <div class="edit-stamp-wrapper">-->
          <!--                        <span>Edited: 05/20/20 4:30 PM</span>-->
          <!--                    </div>-->
          <vue-editor :editor-toolbar="customToolbar" v-model="planContent" class="action-plan-text mb-4" :disabled="disabledSubmitActionPlan"></vue-editor>
          <b-button class="submit-plan-btn" pill @click="$refs['review-modal'].show()" :disabled="disabledSubmitActionPlan">Review Action Plan for Submission</b-button>
        </div>
<!--        <div class="col-md-12 mt-5">-->
<!--          <h6 class="action-plan-header mb-3">Technician Retention Dealer Tools</h6>-->
<!--          <p class="mb-4">The recently submitted Action Plan, the Dealer Assessment Report and The Retention Guide chapters related to the chosen Top Improvement Priority are highlighted. Click to choose and download your preferred tools.</p>-->

<!--          <div class="dealer-tools">-->
<!--            <div>-->
<!--              <b-button class="link-button mr-5" @click="selectAll" variant="link">Select All</b-button>-->
<!--              <b-button class="link-button" @click="clearAll" variant="link">Clear All</b-button>-->
<!--            </div>-->
<!--            <div class="mt-3 guide-button-container">-->
<!--andlt;!andndash;              <b-button id="assessment_report_button" class="dealer-tool-button selected" @click="selectGuide($event, 'assessment_report')" pill>andndash;andgt;-->
<!--andlt;!andndash;                <selected-icon isSelected></selected-icon>andndash;andgt;-->
<!--andlt;!andndash;                Assessment Reportandndash;andgt;-->
<!--andlt;!andndash;              </b-button>andndash;andgt;-->
<!--              <b-button id="introduction_button" class="dealer-tool-button selected" @click="selectGuide($event, 'introduction')" pill>-->
<!--                <selected-icon></selected-icon>-->
<!--                Introduction-->
<!--              </b-button>-->
<!--              <b-button id="compensation_button" class="dealer-tool-button" @click="selectGuide($event, 'compensation')" pill>-->
<!--                <selected-icon></selected-icon>-->
<!--                Compensation-->
<!--              </b-button>-->
<!--              <b-button id="training_button" class="dealer-tool-button" @click="selectGuide($event, 'training')" pill>-->
<!--                <selected-icon></selected-icon>-->
<!--                Training-->
<!--              </b-button>-->
<!--              <b-button id="management_button" class="dealer-tool-button" @click="selectGuide($event, 'management')" pill>-->
<!--                <selected-icon></selected-icon>-->
<!--                Management-->
<!--              </b-button>-->
<!--              <b-button id="dealer_conditions_button" class="dealer-tool-button" @click="selectGuide($event, 'dealer_conditions')" pill>-->
<!--                <selected-icon></selected-icon>-->
<!--                Dealer Conditions-->
<!--              </b-button>-->
<!--              <b-button id="rewards_and_recognition_button" class="dealer-tool-button" @click="selectGuide($event, 'rewards')" pill>-->
<!--                <selected-icon></selected-icon>-->
<!--                Rewards and Recognition-->
<!--              </b-button>-->
<!--              <b-button id="conclusion_button" class="dealer-tool-button selected" @click="selectGuide($event, 'conclusion')" pill>-->
<!--                <selected-icon></selected-icon>-->
<!--                Conclusion-->
<!--              </b-button>-->
<!--            </div>-->

<!--            <div class="mt-4">-->
<!--              <b-button class="retention-guide-btn" pill @click="downloadAssessmentPlan(recentAssessment.id)" :disabled="busy">-->
<!--                {{ this.busy ? "Preparing Download" : "Download" }}-->
<!--              </b-button>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="col-md-12 mt-5">-->
<!--          <h6 class="action-plan-header mb-4">Action Plan History</h6>-->
<!--          <div class="dealer-actions-container">-->
<!--            <div v-for="assessment in assessments" :key="`assessment-${assessment.id}`" class="dealer-action">-->
<!--              <div class="action-date">-->
<!--                <span>{{ format(new Date(assessment.updated_at), 'yyyy/MM/dd hh:mm:ss a') }}</span>-->
<!--              </div>-->
<!--              <div class="action-details">-->
<!--                <h6>{{ assessment.priority }}</h6>-->
<!--                <mq-layout mq="lg+">-->
<!--                  <truncate action-class="more-less-button" collapsed-text-class="collapsed" clamp="MORE" :length="147" less="Show Less" type="html" :text="assessment.action_plan || ''"></truncate>-->
<!--                </mq-layout>-->
<!--                <b-button class="link-button pl-0 pr-0 d-block" variant="link" @click="downloadAssessmentPlan(assessment.id)">Download Plan</b-button>-->
<!--              </div>-->
<!--            </div>-->

<!--          </div>-->
<!--        </div>-->

      </div>

    </div>

  </div>

</template>

<script>
import { format } from 'date-fns';
import ApiService from "../services/api.service";
import { mapMutations, mapState } from 'vuex';
import Axios from "axios";
import _ from 'lodash'

export default {
  name: "Plan",
  components: {
    // SelectedIcon,
    // truncate,
  },
  data(){
    return {
      selected: [],
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
        ["clean"]
      ],
      planContent: null,
      recentAssessment: null,
      assessments: [],
      selectedGuides: ['assessment_report', 'introduction', 'conclusion'],
      busy: false
    }
  },
  created() {
    Promise.all([this.getRecentAssessment(), this.getAssessments()])
      .then((responses) => {
        const [recentAssessment, assessments] = responses.map(response => response.data);
        [this.recentAssessment] = recentAssessment;
        this.assessments = assessments;
        this.selectDealerTools();
        this.populateActionPlan();
      })
  },
  methods: {
    ...mapMutations(['setCurrentUser', 'setCurrentDealership', 'setCurrentPriority', 'setCurrentBenchmarks', 'setCurrentAssessment']),
    downloadAssessmentPlan(id) {
      this.busy = true
      let params = ""
      if (this.selectedGuides.includes("introduction")) {
        params += "introduction=trueand"
      }
      if (this.selectedGuides.includes("compensation")) {
        params += "compensation=trueand"
      }
      if (this.selectedGuides.includes("training")) {
        params += "training=trueand"
      }
      if (this.selectedGuides.includes("management")) {
        params += "management=trueand"
      }
      if (this.selectedGuides.includes("dealer_conditions")) {
        params += "dealer_conditions=trueand"
      }
      if (this.selectedGuides.includes("rewards")) {
        params += "rewards=trueand"
      }
      if (this.selectedGuides.includes("conclusion")) {
        params += "conclusion=trueand"
      }
      let url = `${process.env.VUE_APP_API_URL}api/v1/assessments/${id}/report.pdf?${params}`
      let label = "report"

      Axios.get(url, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/pdf' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = label
          link.click()
          URL.revokeObjectURL(link.href)
          this.busy = false
          console.log("Done downloading")
        }).catch(console.error)
    },
    format,
    getAssessments() {
      const params = {
        'query[s]': 'updated_at desc',
        'query[dealership_eq]': this.currentDealership.name.replace('\'', ''),
      }
      return ApiService.query('api/v1/assessments', { params });
    },
    getRecentAssessment() {
      const params = {
        'query[s]': 'updated_at desc',
        'query[dealership_eq]': this.currentDealership.name.replace('\'', ''),
        per_page: 1
      };
      return ApiService.query('api/v1/assessments', { params });
    },
    submitAction() {
      const params = {
        assessment: {
          action_plan: this.planContent,
          priority: localStorage.getItem('priority'),
          completed: true
        }
      };
      ApiService.update('api/v1/assessments', this.recentAssessment.id, params)
        .then(({ data }) => {
          this.recentAssessment = data;
          this.setCurrentAssessment(this.recentAssessment);
          console.log('updated');
          this.$notify({
            title: "Success!",
            text: "Your assessment results and action plan were successfully submitted and can now be downloaded in the Report Export and History section.",
            type: "success",
            duration: 10_000,
            width: 500,
          });

          // localStorage.removeItem('priority');
          localStorage.removeItem('assessmentForm');
          localStorage.removeItem('reportCheckboxes');
          this.setCurrentBenchmarks(null);

          this.$router.push({ name: 'ReportExport' });

          this.getAssessments().then((data) => {
            this.assessments = data.data;
          })
        })
    },
    selectDealerTools() {
      // var priority = localStorage.getItem('priority');
      // document.getElementById(`${priority.toLowerCase().replace(/ /g,"_")}_button`).click();
    },
    populateActionPlan() {
      var priority = localStorage.getItem('priority');
      var reportCheckboxes = JSON.parse(localStorage.getItem('reportCheckboxes'));

      if (reportCheckboxes == null) {
        priority = this.assessments[0].priority;
        reportCheckboxes = this.assessments[0].priority_checkboxes;
      }

      if (reportCheckboxes == null || reportCheckboxes == undefined) {
        this.$router.push({ name: 'Background' });
        return
      }

      this.planContent = ""

      switch (priority) {
        case "Compensation":
          if (reportCheckboxes["compensation"].c1.length > 0) {
            this.planContent += "<p><strong>COMPENSATION: Annual Income Action Items:</strong></p>\n"
            if (reportCheckboxes["compensation"].c1.includes("q1")) {
              this.planContent += "Understand competitive pay in your area:"
              this.planContent += "<ul><li>Evaluate the pay rates of similar jobs and industries in your area to understand how to price wages competitively</li></ul>"
            }
            if (reportCheckboxes["compensation"].c1.includes("q2")) {
              this.planContent += "Take a pulse of Technician pay satisfaction:"
              this.planContent += "<ul><li>Assess the satisfaction of your Technicians in relation to pay rates. Understand these feelings and address concerns about pay before Technicians leave</li></ul>"
            }
            if (reportCheckboxes["compensation"].c1.includes("q3")) {
              this.planContent += "Conduct a Business Case to assess trade-off costs of raises:"
              this.planContent += "<ul><li>Understand how much you can afford to pay Technicians rather than replacing talent by printing and performing a self-analysis with the information provided in the Retention Guide Appendix</li></ul>"
              this.planContent += "<ul><li>Strive to understand the trade-off based on your specific situation and create a strategy for discussing raises when they are addressed by Technicians</li></ul>"
            }

            this.planContent += "\n\n"
          }
          if (reportCheckboxes["compensation"].c2.length > 0) {
            this.planContent += "<p><strong>COMPENSATION: Pay Plan Methodology and Bonus Structure Action items:</strong></p>\n"
            if (reportCheckboxes["compensation"].c2.includes("q1")) {
              this.planContent += "Guaranteed minimums for apprentices or new hires and production bonuses:"
              this.planContent += "<ul><li>Using the following outline and details regarding pay plans in the Retention guide pages 25-26, institute guaranteed minimum pay plans for Technicians who have recently entered the role\n<strong>Apprentice:</strong> Technicians who have begun at dealerships recently and work in the express lane or have recently switched to the main line\n<strong>Main Line:</strong> Technicians who are responsible for the majority of heavier maintenance repairs, excluding heavy diagnostic work\n<strong>Master Technicians:</strong> Technicians who are responsible for heavy diagnostic work or other repair complications\n<strong>Mentor Technician:</strong> Technician whose primary role is supporting and teaching new Technicians, and is the last line of defence on problem vehicles</li><li>Structure bonuses where Technicians are paid additionally for all hours exceeding their guarantee</li></ul>"
            }
            if (reportCheckboxes["compensation"].c2.includes("q2")) {
              this.planContent += "<ul><li>Implement a system to guarantee new hires minimums for their work and extend programs to compensate for common pain points those technicians face.</li></ul>"
            }
            if (reportCheckboxes["compensation"].c2.includes("q3")) {
              this.planContent += "Hourly Bank:"
              this.planContent += "<ul><li>Compensate and even out production hours by establishing a bank of hours that Technicians can tap into if they are repeatedly provided difficult Repair Orders</li><li>Allot Technicians 40 hours in a ban, which they can access to even out their hours on a bi-weekly basis. For example, if a Technician turns 35 hours in a week but needs 40 hours, they can dip into this bank. At the end of the year, Dealers provide a bonus consisting of unused bank hours</li></ul>"
            }

            this.planContent += "\n\n"
          }
          if (reportCheckboxes["compensation"].c3.length > 0) {
            this.planContent += "<p><strong>COMPENSATION: Benefits Action items:</strong></p>\n"
            if (reportCheckboxes["compensation"].c3.includes("q1")) {
              this.planContent += "<ul><li>Provide Individual Coverage: No-charge individual coverage with family coverage beginning at $100-$125 weekly</li><li>Provide Retirement plan with 2% match</li></ul>"
            }
            if (reportCheckboxes["compensation"].c3.includes("q2")) {
              this.planContent += "<ul><li>Provide family healthcare coverage for no-charge</li><li>Higher Employer Match: Instituting a higher match (3%-5%)</li><li>Financial Education: Offering financial education programs for Technicians and spouses</li><li>Offer Higher PTO Base: Begin new Technicians with 10 PTO days</li></ul>"
            }
            if (reportCheckboxes["compensation"].c3.includes("q3")) {
              this.planContent += "Tool Incentive Programs:"
              this.planContent += "<ul><li>Starter Tool sets: Basic tools necessary for completing jobs for new Technicians when they begin at a dealership</li><li>Tool Credit: Technicians are given starter toolset or a credit for the cost of the tools after one year at the dealership</li></ul>"
              this.planContent += "Tuition incentives:"
              this.planContent += "<ul><li>Reimbursement Credit: Technical vocational programs can cost up to $45,000. We recommend dealerships offer to pay at least 10% of a student's cost anually, resulting in a $4,500 - $5,000 yearly tuition reimbursement program for new Technicians</li></ul>"
            }

            this.planContent += "\n\n"
          }
          break;
        case "Training":
          if (reportCheckboxes["training"].c1.length > 0) {
            this.planContent += "<p><strong>TRAINING: Onboarding Action items:</strong></p>\n"
            if (reportCheckboxes["training"].c1.includes("q1")) {
              this.planContent += "<ul><li>Onboard new Technicians with a dealership tour and review of basic expectations. (e.g., tool and tardiness policies; go to contact for technical questions)</li></ul>"
            }
            if (reportCheckboxes["training"].c1.includes("q2")) {
              this.planContent += "<ul><li>Formally introduce new hires to staff Technicians and provide a social mentor outside of the Service Department to answer generic questions</li></ul>"
            }
            if (reportCheckboxes["training"].c1.includes("q3")) {
              this.planContent += "<ul><li>Review documented Repair Order Processes with new Technicians</li></ul>"
            }
            this.planContent += "\n\n"
          }
          if (reportCheckboxes["training"].c2.length > 0) {
            this.planContent += "<p><strong>TRAINING: Training Class Policies Action Items:</strong></p>\n"
            if (reportCheckboxes["training"].c2.includes("q1")) {
              this.planContent += "<ul><li>Once hired, promptly create a training plan for new Technicians</li></ul>"
            }
            if (reportCheckboxes["training"].c2.includes("q2")) {
              this.planContent += "<ul><li>Monitor training progress and waitlist Technicians for Instructor-Led Training as soon as they are eligible </li></ul>"
            }
            if (reportCheckboxes["training"].c2.includes("q3")) {
              this.planContent += "<ul><li>Reimburse Technicians for lost hours and related expenses. (e.g., travel, lodging, meals)</li></ul>"
            }
            this.planContent += "\n\n"
          }
          if (reportCheckboxes["training"].c3.length > 0) {
            this.planContent += "<p><strong>TRAINING: Career Planning Action Items:</strong></p>\n"
            if (reportCheckboxes["training"].c3.includes("q1")) {
              this.planContent += "<ul><li>Document the career path from new hire to Master Technician</li></ul>"
            }
            if (reportCheckboxes["training"].c3.includes("q2")) {
              this.planContent += "<ul><li>Establish and personalize Technician career paths and monitor progress</li></ul>"
            }
            if (reportCheckboxes["training"].c3.includes("q3")) {
              this.planContent += "<ul><li>Maintain a continuous dialogue to reevaluate Technician goals over time</li></ul>"
            }
            this.planContent += "\n\n"
          }
          if (reportCheckboxes["training"].c4.length > 0) {
            this.planContent += "<p><strong>TRAINING: Mentorship Program Action Items:</strong></p>\n"
            if (reportCheckboxes["training"].c4.includes("q1")) {
              this.planContent += "<ul><li>Create a defined mentorship process, including role definition and timing expectations </li></ul>"
            }
            if (reportCheckboxes["training"].c4.includes("q2")) {
              this.planContent += "<ul><li>Vet mentors and facilitate mentor/apprentice interviews to allow mentors to select their mentees </li></ul>"
            }
            if (reportCheckboxes["training"].c4.includes("q3")) {
              this.planContent += "<ul><li>Rotate mentors and apprentices over time </li></ul>"
            }
            this.planContent += "\n\n"
          }
          break;
        case "Management":
          if (reportCheckboxes["management"].c1.length > 0) {
            this.planContent += "<p><strong>MANAGEMENT: Meeting Schedule Action items:</strong></p>\n"
            if (reportCheckboxes["management"].c1.includes("q1")) {
              this.planContent += "<ul><li>Foster “like family” personal relationships</li><li>Emphasize an open-door policy to provide the ability for Technicians to interact with Managers and voice opinions about the shop's environment or their personal lives</li></ul>"
            }
            if (reportCheckboxes["management"].c1.includes("q2")) {
              this.planContent += "Facilitate structured meetings:"
              this.planContent += "<ul><li>Morning “jump-start” meetings:\nFacilitating gatherings for Technicians and recognizing them in public has proven to have a positive impact on improving Technician satisfaction</li><li>Monthly Individuals Meetings:\nOffering times for individuals to sit down one-on-one to voice opinions creates valuable feedback for Managers and communicates to Technicians that their thoughts are important</li></ul>"
            }
            if (reportCheckboxes["management"].c1.includes("q3")) {
              this.planContent += "<ul><li>Quarterly Surprises: Dealerships that go above and beyond for their employees, providing an exceptional work experience, dramatically affect Technician satisfaction</li></ul>"
            }
            this.planContent += "\n\n"
          }
          if (reportCheckboxes["management"].c2.length > 0) {
            this.planContent += "<p><strong>MANAGEMENT: Error Policy Action items:</strong></p>\n"
            if (reportCheckboxes["management"].c2.includes("q1")) {
              this.planContent += "Outline Processes to Handle Mistakes: Managers should outline criteria for what qualifies an error and how to handle specific mistakes. Dealerships should categorize these errors into accident and neglect, with clear policies relating to each"
            }
            if (reportCheckboxes["management"].c2.includes("q2")) {
              this.planContent += "<ul><li>Communicate Criteria Before Problems Arise: Dealerships that outline these items should articulate these ideas to Technicians before problems arise, so they can anticipate the process for when errors occur</li></ul>"
            }
            if (reportCheckboxes["management"].c2.includes("q3")) {
              this.planContent += "<ul><li>Consistent Practices: While this seems most self-explanatory, the most difficult aspect of the process is handling errors. Mistakes are emotional and it can be easy to veer away from the outlined plan when issues arise. However, high-performing managers should stick to their roadmap for handling errors to address problems consistently</li></ul>"
            }
            this.planContent += "\n\n"
          }
          if (reportCheckboxes["management"].c3.length > 0) {
            this.planContent += "<p><strong>MANAGEMENT: Feedback Mechanisms Action items:</strong></p>\n"
            if (reportCheckboxes["management"].c3.includes("q1")) {
              this.planContent += "<ul><li>Exit interviews: Managers need to understand why Technicians are leaving so that they can address pain points, making these interviews strongly encouraged</li></ul>"
            }
            if (reportCheckboxes["management"].c3.includes("q2")) {
              this.planContent += "<ul><li>End-of-Year Survey: Consider implementing a scheduled annual feedback survey offering a method for Technicians to provide honest feedback anonymously</li></ul>"
            }
            if (reportCheckboxes["management"].c3.includes("q3")) {
              this.planContent += "<ul><li>Quarterly Review Meetings: Dealerships should strive to collect feedback from Technicians as frequently as possible. These meetings are effective because of their regularity and the platform allows for feedback directly to Managers</li></ul>"
            }
            this.planContent += "\n\n"
          }
          break;
        case "Dealer Conditions":
          if (reportCheckboxes["dealerConditions"].c1.length > 0) {
            this.planContent += "<p><strong>DEALER CONDITIONS: Dispatch Method Action items:</strong></p>\n"
            if (reportCheckboxes["dealerConditions"].c1.includes("q1")) {
              this.planContent += "<ul><li>Tiering of Repairs: Dealerships that do not have any system for segmenting work based on skill level should begin by creating a framework</li></ul>"
            }
            if (reportCheckboxes["dealerConditions"].c1.includes("q2")) {
              this.planContent += "<ul><li>Performance Monitoring System: Dealerships that have the proper dispatch systems should monitor their processes to ensure they operate efficiently</li></ul>"
            }
            if (reportCheckboxes["dealerConditions"].c1.includes("q3")) {
              this.planContent += "<ul><li>Dealership Production Bonus: Dealerships should offer attractive bonuses to dispatch personnel to ensure that they are motivated to distribute work evenly across all Technicians</li><li>8:1 Ratio: Top performers have the optimal ratio of dispatch personnel to Technicians, guaranteeing a sufficient level of support</li></ul>"
            }
            this.planContent += "\n\n"
          }
          if (reportCheckboxes["dealerConditions"].c2.length > 0) {
            this.planContent += "<p><strong>DEALER CONDITIONS: Work Processes Action items:</strong></p>\n"
            if (reportCheckboxes["dealerConditions"].c2.includes("q1")) {
              this.planContent += "<ul><li>Understanding Bottleneck Processes: To understand where " +
                "Technicians are losing production time, managers need to " +
                "evaluate their own dealership’s operations. The severity of lost " +
                "production will vary between dealerships, making it crucial to " +
                "understand your own environment to make changes to the most " +
                "essential items</li><li>Updated Tools and Equipment: These items are " +
                "relatively low cost to dealerships and are crucial considering the " +
                "frequency of their use. Having an adequate supply of parts and " +
                "equipment prevents bottlenecking and streamlines processes " +
                "for Technicians</li></ul>"
            }
            if (reportCheckboxes["dealerConditions"].c2.includes("q2")) {
              this.planContent += "<ul><li>Provide Technicians with a form of direct communication with Service Managers, Service Advisors, Shop Foremen, and the Parts Department to increase time in their bay (e.g., walkie-talkie, instant message, and text message)</li></ul>"
            }
            if (reportCheckboxes["dealerConditions"].c2.includes("q3")) {
              this.planContent += "<ul><li>Porters or Parts Runners: While " +
                "hiring these individuals may have a " +
                "higher initial cost, the investment " +
                "still pays dividends by making " +
                "Technicians more productive and " +
                "increasing satisfaction</li></ul>"
            }
            this.planContent += "\n\n"
          }
          if (reportCheckboxes["dealerConditions"].c3.length > 0) {
            this.planContent += "<p><strong>DEALER CONDITIONS: Facility Standards Action items:</strong></p>\n"
            if (reportCheckboxes["dealerConditions"].c3.includes("q1")) {
              this.planContent += "<ul><li>Dealership-Supplied Uniforms: Three to five sets of " +
                "uniforms should be provided to Technicians to ensure " +
                "they can come to work every day looking clean and " +
                "professional</li><li>Uniform Standards: Dealerships should begin by creating " +
                "detailed expectations of how Technicians should present " +
                "themselves at dealerships</li><li>Cleanliness Standards: Managers should meet with " +
                "Technicians to outline the standard for a bay in terms of " +
                "organization, and hold individuals accountable for not " +
                "respecting the space</li><li>Safety Standards: Safety processes should be clearly " +
                "documented, and resources supplied to Technicians, as " +
                "well as an orientation around how to properly use certain " +
                "equipment</li></ul>"
            }
            if (reportCheckboxes["dealerConditions"].c3.includes("q2")) {
              this.planContent += "<ul><li>Replacement Uniforms: Managers should " +
                "communicate to Technicians the policy for " +
                "replacing uniforms whenever damages " +
                "occur, and these individuals should work " +
                "diligently to provide adequate supplies for " +
                "their personnel</li><li>Amenities: Dealerships should provide " +
                "Technicians a clean locker room or a break " +
                "area so that they have a place that is theirs " +
                "to relax during lunch or other downtime</li></ul>"
            }
            if (reportCheckboxes["dealerConditions"].c3.includes("q3")) {
              this.planContent += "<ul><li>Professional Cleaning: While this may seem " +
                "like an unnecessary investment, the changes " +
                "this creates mentally within the shop " +
                "significantly improves the value that " +
                "Technicians feel</li><li>Laundry Service: While this varies on other " +
                "items, like locker rooms, it is a clear way to " +
                "take care of Technicians and separate " +
                "dealerships as leaders in the space</li><li>Amenities: Industry leaders supply " +
                "Technicians top-tier facilities, including " +
                "heating, air conditioning, noise tarps, as well " +
                "as other items that are specific to certain " +
                "areas or business needs</li></ul>"
            }
            this.planContent += "\n\n"
          }
          if (reportCheckboxes["dealerConditions"].c4.length > 0) {
            this.planContent += "<p><strong>DEALER CONDITIONS: Dealership Culture Action items:</strong></p> "
            if (reportCheckboxes["dealerConditions"].c4.includes("q1")) {
              this.planContent += "<ul><li>Public Recognition for " +
                "Collaboration: Dealerships should " +
                "acknowledge those who are " +
                "helping others in front of all other " +
                "Service personnel</li><li>Group Outings: Managers should " +
                "run events for Technicians to " +
                "create close bonds outside the " +
                "dealership</li></ul>"
            }
            if (reportCheckboxes["dealerConditions"].c4.includes("q2")) {
              this.planContent += "<ul><li>Sporting Leagues: Dealership-" +
                "sponsored sporting leagues where " +
                "individuals meet weekly or biweekly. Examples of these leagues " +
                "include: Bowling, Softball, and Flag football</li></ul>"
            }
            if (reportCheckboxes["dealerConditions"].c4.includes("q3")) {
              this.planContent += "<ul><li>Collaboration Bonus: Dealers should " +
                "provide a " +
                "small bonus to Technicians who go " +
                "above and " +
                "beyond in assisting their peers</li></ul>"
            }
            this.planContent += "\n\n"
          }
          break;
        case "Rewards & Recognition":
          if (reportCheckboxes["rewards"].c1.length > 0) {
            this.planContent += "<p><strong>REWARDS AND RECOGNITION: Reward Programs and Special Bonuses:</strong></p>\n"
            if (reportCheckboxes["rewards"].c1.includes("q1")) {
              this.planContent += "<strong>Morning Meeting Recognition:</strong> " +
                "Managers should begin with " +
                "implementing this practice due to its " +
                "high impact and low cost. Dealerships " +
                "have reiterated the power of " +
                "recognizing their staff in public and the " +
                "benefits this has on increasing positive " +
                "sentiments throughout the Service " +
                "Department"
            }
            if (reportCheckboxes["rewards"].c1.includes("q2")) {
              this.planContent += "<b>Employee of The Month:</b> " +
                "Consistently host a monthly meeting collecting all Technicians and recognizing individuals using " +
                "the following criteria: <strong>Format:</strong> Meeting involving all Technicians, the Service Manager, and General Manager where " +
                "senior leaders acknowledge high achievers <strong>Qualifier:</strong> Recognize: <ul><li>Top Producer: Technician who turned the most hours</li><li>Performing Above Average: Technicians who performed five more hours above their " +
                "previous month’s average</li></ul>" +
                "<strong>Reward:</strong> Public recognition by a Service Manager <strong>Daily Challenges:</strong> " +
                "Post a challenge for the day and the first individual to " +
                "reach the goal receives a prize. Aspects of this program may vary, but we recommend the " +
                "following format: " +
                "<strong>Frequency:</strong> Spontaneously year-round, but offered at least once a quarter " +
                "<strong>Format:</strong> Mangers come into the Service Department and post a challenge of the day, typically in " +
                "terms of hours produced. " +
                "<strong>Qualifier:</strong> The Technician that reaches the goal first, such as 10 hours turned, receives the prize " +
                "for the day. " +
                "<strong>Reward:</strong> Technicians who win receive a small cash prize ranging from $20-$50. This amount will " +
                "vary between dealerships and is ultimately up " +
                "to management"
            }
            if (reportCheckboxes["rewards"].c1.includes("q3")) {
              this.planContent += "<ul><li><strong>Token Program:</strong> Challenge Technicians to meet " +
                "specific goals in terms of production hours or FIRTFT " +
                "scores and " +
                "offer rewards redeemed with earned “tokens”</li><li><strong>Exceptional Customer Service “Wow” Program:</strong> " +
                "Challenge Technicians to provide exceptional " +
                "customer service. " +
                "This service can range from fixing a broken glove box " +
                "that was not reported to purchasing a gift card for a " +
                "customer. We encourage Technicians to be creative</li><li><strong>Weekend Bonus:</strong> Technicians indicate how this can " +
                "make the difference between a good and bad " +
                "Saturday, the gesture Managers make are important " +
                "in recognizing the extra time individuals contribute</li></ul>"
            }
            this.planContent += "\n\n"
          }
          if (reportCheckboxes["rewards"].c2.length > 0) {
            this.planContent += "<p><strong>REWARDS AND RECOGNITION: Workday Perks</strong></p> "
            if (reportCheckboxes["rewards"].c2.includes("q1")) {
              this.planContent += "Birthdays: Managers should begin " +
                "with celebrating birthdays for " +
                "Technicians, as it is a simple " +
                "program that is low cost and high " +
                "impact\n"
            }
            if (reportCheckboxes["rewards"].c2.includes("q2")) {
              this.planContent += " High-end Coffee Bar: Dealerships should " +
                "consider instituting this policy, or " +
                "expanding on their existing setup, " +
                "to cater to Technicians and " +
                "emphasize their importance\n"
            }
            if (reportCheckboxes["rewards"].c2.includes("q3")) {
              this.planContent += " Saturday Lunches: Managers should " +
                "provide Technicians lunches on the " +
                "weekend and express that they " +
                "appreciate the extra effort that these " +
                "individuals put forward\n"
            }
            this.planContent += "\n\n"
          }
          if (reportCheckboxes["rewards"].c3.length > 0) {
            this.planContent += "<p><strong>REWARDS AND RECOGNITION: Tenure Benefits</strong></p> "
            if (reportCheckboxes["rewards"].c3.includes("q1")) {
              this.planContent += "Incremental Milestone " +
                "Ceremonies: Dealerships should " +
                "offer public recognition to " +
                "Technicians for hitting incremental " +
                "milestones and commitment to " +
                "the business\n"
            }
            if (reportCheckboxes["rewards"].c3.includes("q2")) {
              this.planContent += " Master Technician Award " +
                "Ceremony: General Managers " +
                "should recognize Technicians when " +
                "they achieve this rank and provide " +
                "the rewards (e.g., Badges, plaques, " +
                "dinners and trip bonuses)\n"
            }
            if (reportCheckboxes["rewards"].c3.includes("q3")) {
              this.planContent += " Tenure Trips: Trips for Technicians who " +
                "achieve specific statuses or have been " +
                "with the dealership for a prolonged " +
                "period of time should be recognized " +
                "for their commitment with trips such " +
                "as a weekend vacation trip to a " +
                "desirable location of their choice\n"
            }
            this.planContent += "\n\n"
          }
          break;


      }
    },
    selectGuide(event, data) {
      const button = event.target;
      button.classList.toggle('selected');

      if (button.classList.contains('selected')) {
        if (!this.selectedGuides.includes(data)) {
          this.selectedGuides.push(data)
        }
      } else {
        if (this.selectedGuides.includes(data)) {
          var index = this.selectedGuides.indexOf(data);
          if (index !== -1) {
            this.selectedGuides.splice(index, 1);
          }
        }
      }
    },
    selectAll() {
      let dealerToolButtons = document.getElementsByClassName("dealer-tool-button");
      for (let i = dealerToolButtons.length - 1; i >= 0; --i){
        if (!dealerToolButtons[i].classList.contains('selected')){
          dealerToolButtons[i].click();
        }
      }
    },
    clearAll() {
      let dealerToolButtons = document.getElementsByClassName("dealer-tool-button");
      for (let i = dealerToolButtons.length - 1; i >= 0; --i){
        if (dealerToolButtons[i].classList.contains('selected')){
          dealerToolButtons[i].click();
        }
      }
    }
  },
  computed: {
    ...mapState(['currentDealership']),
    disabledSubmitActionPlan() {
      return this.recentAssessment === undefined || this.recentAssessment === null;
    }
  },
  watch: {
    planContent: {
      handler: _.debounce(function () {
        console.debug("Saving action plan")

        const params = {
          assessment: {
            action_plan: this.planContent,
          }
        };

        ApiService.update('api/v1/assessments', this.recentAssessment.id, params)
          .then(({ data }) => {
            this.recentAssessment = data;
          })

      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>

.submit-modal-btn {
  @extend .custom-button;
  font-size: 18px;
  letter-spacing: 1px;
  min-width: 250px;
  box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.1);
}

.cancel-modal-btn {
  @extend .custom-button;
  text-transform: uppercase;
  color: grey;
  background-color: transparent;
  font-size: 18px;
  letter-spacing: 1px;
  min-width: 250px;
  box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.1);
  and:hover {
    //background-color: #2861a4;
    color: inherit;
    background-color: inherit;
  }
}

#plan {
  padding: 25px 30px 40px;
  @media (max-width: 576px) {
    padding: 25px 15px 40px;
  }
  .retention-guide-btn {
    @extend .custom-button-inverted;
    font-size: 18px;
    letter-spacing: 1px;
  }
  .action-plan {
    .action-plan-header {
      font-family: FordAntennaCond-Regular, sans-serif;
      text-transform: uppercase;
      color: $fordBlue;
      letter-spacing: 1px;
    }
    .edit-stamp-wrapper {
      background-color: #EEF2F5;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      padding: 5px 15px 0;
      span {
        font-size: 11px;
        letter-spacing: 0;
        color: #5b7886;
      }
    }
    textarea {
      width: 100%;
      height: 200px;
      resize: none;
    }
    .submit-plan-btn {
      @extend .custom-button;
      font-size: 18px;
      letter-spacing: 1px;
      min-width: 250px;
      box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.1);
    }
    .guide-button-container {
      .dealer-tool-button {
        @extend .custom-button;
        color: #263238;
        letter-spacing: .34px;
        background-color: $lightGrey;
        border: 1px solid rgb(124,153,171);
        transition: background-color .5s;
        and:not(last-of-type) {
          margin: 0 10px 10px 0;
        }
        span {
          color: inherit;
          svg {
            color: inherit;
            path {
              color: inherit;
            }
          }
        }
        and:hover {
          background-color: #2861a4;
          color: $white;
          border: 1px solid #2861a4;
        }
        and.selected {
          color: $white;
          background-color: $fordBlue;
          border: 1px solid $fordBlue;
          and:hover {
            background-color: #2861a4;
            border: 1px solid #2861a4;
            color: $white;
          }
        }
      }
    }
    .dealer-actions-container {
      overflow-y: auto;
      max-height: 580px;
      .dealer-action {
        display: flex;
        flex-direction: row;
        and:not(:last-of-type) {
          border-bottom: 1px solid #c9d6dc;
          padding-bottom: 25px;
          margin-bottom: 25px;
        }
        .action-date {
          width: 70px;
          text-align: center;
          span {
            font-size: 12px;
            font-family: FordAntennaCond-Regular, sans-serif;
          }
        }
        .action-details {
          padding-left: 15px;
          h6 {
            color: $fordBlue;
            letter-spacing: 0.81px;
            font-size: 13px;
          }
          /deep/ span {
            font-family: FordAntennaCond-Regular, sans-serif;
            letter-spacing: 0.88px;
          }
          /deep/ .collapsed {
            font-family: FordAntennaCond-Regular, sans-serif;
            letter-spacing: 0.88px;
            and::after {
              content: "..."
            }
          }
          /deep/ .more-less-button {
            @extend .link-button;
            border: 0;
            background-color: transparent;
            padding: 1px 0;
          }
        }
      }
    }
  }
}
</style>
